<template>
<div :class="{ navbtn: true, active: act}">
  <a><slot></slot></a>
  <div class="triangle"></div>
</div>
</template>

<script>
export default {
  name: 'NavButton',
  props: ['active'],
  computed: {
    act() {
      return (this.active);
    },
  },
};
</script>

<style lang="scss">
.navbtn {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  font-size: 20px;
  position: relative;
  border-bottom: 2px solid transparent;
  transition: all .2s ease;
  cursor: pointer;
  &:hover {
    border-bottom: 2px solid #fff;
    a {
      color: #fff;
    }
  }
  &.active {
    background: linear-gradient(to bottom right, #1880CF, #2D8BD4);
    border-bottom: 2px solid #fff;
    a {
      color: #fff;
      text-shadow: 0 0 6px rgba(#000, .35);
    }
    .triangle {
      border-bottom: 10px solid #fff;
    }
  }
  .triangle {
    /*border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid transparent;*/
    border: 10px solid transparent;
    width: 0;
    height: 0;
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  a {
    color: $text_gray;
    text-decoration: none;
    transition: all .2s ease;
  }
}

@media screen and (max-width: 500px) {
  .navbtn {
    border-left: 3px solid transparent;
    border-bottom: none;
    height: 50px;
    background: $dark_bg;
    &:hover {
      border-left: 3px solid #fff;
      border-bottom: none;
    }
    &.active {
      border-left: 3px solid #fff;
      border-bottom: none;
      .triangle {
        border-left: 10px solid #fff;
        border-bottom: none;
      }
    }
    .triangle {
      right: auto;
      left: -15px;
      top: -5px;
      bottom: 0;
      margin: auto 0;
      border: 10px solid transparent;
      padding-bottom: 5px;
      transform: rotate(225deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/NavButton.vue